import { Route, Router, Switch, useHistory, useRouteMatch } from 'react-router';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';
import withRole from 'components/Security/withRole';
import { ROLE_EDIT_ORDER, ROLE_SHOW_ORDER } from 'helpers/roles';

import List from './Diets.container';
import Form from './Details/DietDetails.container';

const Diets = () => {
  const match = useRouteMatch();
  const history = useHistory();

  const ListSecured = withRole(ROLE_SHOW_ORDER, List);
  const EditForm = withRole(ROLE_EDIT_ORDER, Form);

  return (
    <DataGridStateContextProvider>
      <Router history={history}>
        <Switch>
          <Route
            exact={true}
            path={`${match.url}/`}
            render={parentProps => <ListSecured {...parentProps} />}
          />
          <Route
            path={`${match.url}/preview/:id`}
            render={parentProps => (
              <EditForm
                dietId={parentProps.match.params.id}
                setDietId={id => {
                  history.push(`/admin/ecommerce-diets/preview/${id}`);
                }}
              />
            )}
          />
        </Switch>
      </Router>
    </DataGridStateContextProvider>
  );
};

export default Diets;
